'use client'
import cl from 'clsx'
import Image from 'next/image'
import { useEffect, useRef, useState } from 'react'
import arrowButtom from '@/public/icons/arrow-bottom.svg'
import arrowTop from '@/public/icons/arrow-top.svg'
import { languages } from '@/static/data/language'
import styles from './styles.module.css'
import useLanguagesStore from '@/store/languages'

export default function SelectLanguage( ) {
    const { toggleSelect, setLanguage } = useLanguagesStore();
    const [open, setOpen] = useState(false);
    const [selectedLanguages, setSelectedLanguages] = useState('EN');
    const [selectedLanguagesId, setSelectedLanguagesId] = useState(null);
    const selectRef = useRef(null);

    useEffect(() => {
        setLanguage(selectedLanguages.toLowerCase());
    }, [selectedLanguages]);

    const getLanguageFromCookies = () => {
        const cookies = document.cookie.split('; ');
        const savedLanguage = cookies.find(row => row.startsWith('selectedLanguage='));
        return savedLanguage ? savedLanguage.split('=')[1].toUpperCase() : null;
    };

    useEffect(() => {
        const savedLanguage = getLanguageFromCookies();
        if (savedLanguage) {
            setSelectedLanguages(savedLanguage);
            const selectedLang = languages.find(lang => lang.title.toUpperCase() === savedLanguage);
            if (selectedLang) {
                setSelectedLanguagesId(selectedLang.id);
            }
        }
    }, []);

    const selectLanguage = (id, title) => {
        setSelectedLanguages(title);
        setSelectedLanguagesId(id);
        setOpen(!open);
        toggleSelect(true)
        localStorage.setItem('selectLanguage', 'true');
        document.cookie = `selectedLanguage=${title?.toLowerCase()}; path=/; max-age=31536000`;
        const supportedLocales = ['en', 'uk', 'de'];
        let currentPath = window.location.pathname;
        let pathSegments = currentPath.split('/');
        pathSegments = pathSegments.filter(segment => !supportedLocales.includes(segment) && segment !== "");
        pathSegments.unshift(title.toLowerCase());
        const newPath = '/' + pathSegments.join('/');
        if (newPath !== currentPath) {
            window.location.href = newPath;
        }
    };

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <div className={styles.selectLanguage} ref={selectRef}>
            <div
                onClick={() => setOpen(!open)}
                className={styles.selectLanguage__lable}
            >
                <p className={styles.selectLanguage__title}>{selectedLanguages}</p>
                <Image src={open ? arrowTop : arrowButtom} alt='arrow bottom' />
            </div>

            {open && (
                <div className={styles.selectLanguage_selectedList}>
                    {languages.map(({ id, title }) => (
                        <div
                            key={id}
                            onClick={() => selectLanguage(id, title)}
                            className={cl(
                                styles.selectLanguage__text,
                                { [styles.active]: selectedLanguagesId === id }
                            )}
                        >
                            {title}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
